import { Button } from "@/components/ui/button";
import { viewBillingAll } from "@/constants/page-permissions";
import usePermissions from "@/hooks/use-permissions";
import { Loader2 } from "lucide-react";
import { FC, PropsWithChildren, Suspense } from "react";
import { Link } from "react-router";
import BackTrigger from "./back-trigger";
import NavUser from "./nav-user";

const BillingLayout: FC<PropsWithChildren> = ({ children }) => {
  const { can } = usePermissions();

  return (
    <div className="flex flex-col min-h-screen">
      <header className="sticky top-0 flex shrink-0 items-center justify-between bg-background py-4 px-2 md:px-4 z-40">
        <div className="flex w-full gap-2">
          <BackTrigger mode="strict" to="/" />
          <h1 className="text-xl truncate font-semibold">Біллінг</h1>
        </div>
        {can(viewBillingAll) && (
          <Button variant="link" className="text-blue-500" asChild>
            <Link to="/settings/billing/all">Весь</Link>
          </Button>
        )}
      </header>

      <Suspense fallback={<Loader2 className="m-auto animate-spin" />}>
        <main className="flex-1 overflow-auto flex flex-col">{children}</main>
      </Suspense>

      <footer className="sticky bottom-0 border-t bg-background w-full overflow-x-auto p-2 z-40 rounded-t-xl">
        <NavUser />
      </footer>
    </div>
  );
};

export default BillingLayout;
